import React from 'react';
import { Link } from 'react-router-dom';

const featuredNews = [
  { id: 1, title: 'Kabinet presenteert nieuwe begroting', excerpt: 'Het kabinet heeft vandaag de begroting voor 2026 gepresenteerd met forse investeringen in zorg en infrastructuur.', category: 'Binnenland', time: '2 uur geleden' },
  { id: 2, title: 'Verkiezingen in zicht: peilingen tonen verschuiving', excerpt: 'Nieuwe peilingen tonen een verschuiving naar kleinere partijen in aanloop naar de verkiezingen.', category: 'Verkiezingen', time: '4 uur geleden' },
  { id: 3, title: 'Tweede Kamer debatteert over klimaatwet', excerpt: 'De Tweede Kamer bespreekt vandaag de aangescherpte klimaatdoelstellingen.', category: 'Klimaat', time: '6 uur geleden' },
];

export default function HomePage() {
  return (
    <div>
      <section className="bg-gradient-to-r from-red-700 to-blue-700 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-bold mb-6">PolitiekDirect</h1>
          <p className="text-2xl mb-8 opacity-90">Onafhankelijk politiek nieuws en analyse</p>
          <Link to="/nieuws" className="bg-white text-red-700 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition">
            Lees het laatste nieuws
          </Link>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-gray-800">Uitgelicht</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {featuredNews.map(news => (
              <article key={news.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition">
                <img src={`https://picsum.photos/seed/politics${news.id}/400/200`} alt={news.title} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-sm text-red-600 font-semibold">{news.category}</span>
                    <span className="text-sm text-gray-500">{news.time}</span>
                  </div>
                  <h3 className="text-xl font-bold mb-3">{news.title}</h3>
                  <p className="text-gray-600 mb-4">{news.excerpt}</p>
                  <Link to={`/nieuws/${news.id}`} className="text-red-600 font-semibold hover:text-red-800">Lees verder →</Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-gray-100 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-center text-gray-800">Populaire Partijen</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {['VVD', 'D66', 'PVV', 'CDA', 'GroenLinks', 'PvdA', 'SP', 'ChristenUnie'].map(party => (
              <Link key={party} to={`/partijen#${party}`} className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition">
                <div className="w-16 h-16 bg-gradient-to-r from-red-500 to-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center text-white font-bold">
                  {party.charAt(0)}
                </div>
                <h3 className="font-bold">{party}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
